import { defineGraphqlClientOptions } from 'nuxt-graphql-middleware/client-options'
import { useCurrentLanguage, useRuntimeConfig } from '#imports'

export default defineGraphqlClientOptions<{
  language: string
  hash: string
  env: 'client' | 'server'
}>({
  buildClientContext() {
    // @ts-ignore This is a bug in vue-tsc: It thinks that this is using the server util, which requires the H3Event as an argument.
    const language = useCurrentLanguage()
    const config = useRuntimeConfig()

    return {
      // @ts-ignore See above.
      language: language.value,
      hash: config.public.buildHash,
      env: import.meta.server ? 'server' : 'client',
    }
  },
})
